import React from "react";

export default ({executorStatus, complaints}) => {

    let title = '';
    if(executorStatus === 5) title = 'Спорная ситуация. Жалоба на рассмотрении админстратора.'
    else if(executorStatus === 6) title = 'Жалоба заказчика была принята';
    else if(executorStatus === 4) title = 'Жалоба заказчика была отклонена';

    return  <div className="complaints">
                <h3>{title}</h3>
                {
                    complaints.map((item, index) =>
                        <div key={index} className="complaint__item">
                            <div className="complaint__text">{item.content}</div>
                            {
                                item.admin_response && item.admin_response.trim().length
                                ?
                                <div className="complaint__response">
                                    <div className="complaint__person">Ответ администратора</div>
                                    <div>{item.admin_response}</div>
                                </div>
                                : null
                            }
                        </div>
                    )
                }
            </div>
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/ComplaintListParticipant.js